import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import {
  addCourseCategory,
  deleteCourseCategory,
  getCourseCategories,
  updateCourseCategory,
} from "../../Services/HomeService";
import Swal from "sweetalert2";

const CourseCategory = () => {
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] =
    useState(false);
  const [createCourseCategoryObject, setCreateCourseCategoryObject] = useState({
    name: "",
  });
  const [createCourseCategoryLoading, setCreateCourseCategoryLoading] =
    useState(false);

  const [editCourseCategory, setEditCourseCategory] = useState(null);

  const [updateCourseCategoryLoading, setUpdateCourseCategoryLoading] =
    useState(false);

  const fetchCourseCategories = async () => {
    try {
      setCourseCategoriesLoading(true);
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
        setCourseCategoriesLoading(false);
      } else {
        toast.error("Error while Fetching Course Categories Data");
        setCourseCategoriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
      setCourseCategoriesLoading(false);
    }
  };

  useEffect(() => {
    fetchCourseCategories();
  }, []);

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Course Category Name",
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                handleUpdateClick(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const handleCreateCourseCategory = async (e) => {
    e?.preventDefault();
    console.log("hi", createCourseCategoryObject);
    if (!createCourseCategoryObject?.name) {
      toast.error("Please Enter All Fields");
      return;
    }
    try {
      setCreateCourseCategoryLoading(true);
      const res = await addCourseCategory(createCourseCategoryObject);
      console.log("Course Category Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setCreateCourseCategoryObject((prev) => ({ ...prev, name: "" }));
        fetchCourseCategories();
        setCreateCourseCategoryLoading(false);
      } else {
        toast.error(res?.message);
        setCreateCourseCategoryLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Course Category.");
      console.error("Error adding Course Category:", error);
      setCreateCourseCategoryLoading(false);
    }
  };

  const handleUpdateClick = (row) => {
    setEditCourseCategory(row);
  };

  const handleCancel = () => {
    setEditCourseCategory(null);
  };

  const handleUpdateCourseCategory = async (e) => {
    e?.preventDefault();

    if (!editCourseCategory?.name) {
      toast.error("Please Enter All Fields");
      return;
    }
    try {
      setUpdateCourseCategoryLoading(true);
      const res = await updateCourseCategory(
        editCourseCategory?._id,
        editCourseCategory
      );
      console.log("Course Category Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setEditCourseCategory(null);
        fetchCourseCategories();
        setUpdateCourseCategoryLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateCourseCategoryLoading(false);
      }
    } catch (error) {
      toast.error("Failed to Update Course Category.");
      console.error("Error Update Course Category:", error);
      setUpdateCourseCategoryLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Course Category?",
      text: "Are you sure you want to delete this Course Category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteCourseCategory(id);
        Swal.fire("Deleted!", "Course Category has been deleted.", "success");
        // toast.error("Deleted Successfully");
        fetchCourseCategories();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Course Category.", "error");
      }
    }
  };

  return (
    <>
      {!editCourseCategory && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage Course Category
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreateCourseCategory(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Course Category Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={createCourseCategoryObject?.name}
                      onChange={(e) =>
                        setCreateCourseCategoryObject((prev) => ({
                          ...prev,
                          name: e?.target?.value,
                        }))
                      }
                      placeholder="Enter Course Category Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={createCourseCategoryLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {createCourseCategoryLoading
                      ? "Loading..."
                      : "Add Course Category"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editCourseCategory && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={courseCategories}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchCourseCategoriesLoading}
              />
            </section>
          </div>
        </div>
      )}
      {editCourseCategory && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update Course Category
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdateCourseCategory(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Course Category Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={editCourseCategory?.name}
                      type="text"
                      id="name"
                      className="form-control"
                      onChange={(e) =>
                        setEditCourseCategory((prev) => ({
                          ...prev,
                          name: e?.target?.value,
                        }))
                      }
                      placeholder="Enter Course Category Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={updateCourseCategoryLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {updateCourseCategoryLoading
                      ? "Loading..."
                      : "Update Course Category"}
                  </button>
                  <button
                    onClick={() => {
                      handleCancel();
                    }}
                    disabled={updateCourseCategoryLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default CourseCategory;
